export default class ConsumerAssetsError extends Error {
    constructor(message = 'Maximum number of attempts to get consumer assets has been exceeded', ...args) {
        super(...args);
        this.message = message;
    }
}
